/** Explicit statement charge classification; jurisdiction is independent of book framework. */
export const TRANSFER_CHARGE_RULES = {
  TARIFA: { jurisdiction: 'GLOBAL', systemSlot: 'AP_TARIFAS_BANCARIAS' },
  IOF: { jurisdiction: 'BR', systemSlot: 'AP_IOF' },
  IRRF: {
    jurisdiction: 'BR',
    recoverableSlot: 'IRRF_COMPENSAR',
    definitiveSlot: 'OP_INVESTMENT_IRRF_DEFINITIVE',
  },
} as const;

export type TransferChargeType = keyof typeof TRANSFER_CHARGE_RULES;
export type TransferChargeSide = 'DEBIT' | 'CREDIT';

export interface TransferChargeDimensions {
  managerialAccountId?: string;
  costCenterId?: string;
  departmentId?: string;
}

export interface TransferChargePosting extends TransferChargeDimensions {
  adjustmentId: string;
  adjustmentType: TransferChargeType;
  amount: string;
  side: TransferChargeSide;
}
